import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';


// Pill-button styles copied from the "Active (In scope)" / "Archived" toggles
// (FilterCMArchive) in Shared/DataTable/DataTable.js so the Open / Completed
// switch matches the Compliance Manager look.
const filterBaseStyle = {
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
};

const inactiveStyle = {
    ...filterBaseStyle,
    color: "#5f6368",
    border: "1px solid #a0aec0",
    backgroundColor: "#ffffff",
};

const activeStyle = {
    ...filterBaseStyle,
    color: "#203864",
    border: "1px solid #a0aec0",
    backgroundColor: "#e8f0fe",
};


const CustomMenuBar= ({ context }) => {

    const [view, setView] = useState("true");

    const AppContext = context;

    const changeView = (view) => {

        setView(view);

        AppContext.setSelectedFilterSubmissionsOpen(view);

        AppContext.clearAllFilters();

    }


    return (
        <>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                    marginBottom: "15px",
                    marginLeft: "17px",
                    marginTop: "10px"
                }}
            >
                <span
                    onClick={() => changeView("true")}
                    style={view == "true" ? activeStyle : inactiveStyle}
                >
                    <i
                        className={view == "true" ? "fas fa-check-square" : "far fa-square"}
                        style={{ marginRight: '6px', fontSize: '12px' }}
                    ></i>
                    Open
                </span>

                <span
                    onClick={() => changeView("false")}
                    style={view == "false" ? activeStyle : inactiveStyle}
                >
                    <i
                        className={view == "false" ? "fas fa-check-square" : "far fa-square"}
                        style={{ marginRight: '6px', fontSize: '12px' }}
                    ></i>
                    Completed
                </span>
            </div>

            {AppContext.legalManufacturerId && AppContext.certificateId == undefined && 
                <>
                <div style={{ marginTop: "10px", marginBottom: "15px", textAlign: "left", width: "100%", marginLeft: "15px" }}>
                    <span className="filtered-by-legal-manufacturer-tag">
                        <i className="fas fa-info-circle"></i> This list is filtered by legal manufacturer "<strong>{AppContext.legalManufacturerName}</strong>". Change it <a href="/your-medboard/country-registrations/">here</a>
                    </span>
                </div>
                </>
            }


        </>
    );
};


export default CustomMenuBar;